import * as api from 'syft-acp-core/api/resources/admin/conversations'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('ADMIN_CONVERSATIONS_FETCH', api.fetchAdminConversations)
  yield takeLatestApiCall('ADMIN_CONVERSATION_FETCH', api.fetchAdminConversation)
  yield takeLatestApiCall('ADMIN_CONVERSATION_MESSAGES_FETCH', api.fetchAdminConversationMessages)
}
